import { styled } from '@mui/material/styles';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { Footer } from '../components/Footer';
import { TableHead } from '../components/TableHead';
import { Toolbar } from '../components/Toolbar';
import { useDataProvider } from '../DataProviderContext';
import { HeadRow } from '../flat/components/HeadRow';
import Skeleton from '../flat/components/Skeleton';
import { useIsRowClickable } from '../hooks/useIsRowClickable';
import { ExpandableRow } from './components/ExpandableRow';

const Table = styled(MuiTable, { name: 'StructuredTable', slot: 'Table' })({
  // Show borders in table headers when using sticky
  borderCollapse: 'separate',
});

const Root = styled('div', { name: 'StructuredTable', slot: 'Root' })({
  width: '100%',
  overflowX: 'auto',
  maxHeight: '100%',
});

export const StructuredTable = () => {
  const { table, isLoading, isRowHighlighted, onRowClick } = useDataProvider();
  const isRowClickable = useIsRowClickable();

  if (!table) {
    return null;
  }

  if (isLoading) {
    return (
      <Root>
        <Skeleton />
      </Root>
    );
  }

  return (
    <Root>
      <Toolbar />
      <Table>
        <TableHead>
          {table.getHeaderGroups().map((headerGroup) => (
            <HeadRow headerGroup={headerGroup} key={headerGroup.id} />
          ))}
        </TableHead>
        <TableBody>
          {table.getRowModel().rows.map((row) => {
            const isClickable = isRowClickable(row);
            const isHighlight = isRowHighlighted?.(row);

            return (
              <ExpandableRow
                row={row}
                isClickable={isClickable}
                isHighlight={isHighlight}
                onClick={onRowClick}
                key={row.id}
              />
            );
          })}
        </TableBody>
      </Table>
      <Footer />
    </Root>
  );
};
